<div class="container-fluid mt-3">
<!--      <prettyjson [obj]="observerForm.value"></prettyjson>-->
  <h2 class="text-center mb-3">{{ currentEditId ? 'Update Education Observation':'Add Education Observation' }}</h2>
  <form [formGroup]="observerForm" class="row" autocomplete="off">
    <!-- Session Date -->
    <div class="col-md-4 mb-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Session Date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="sessionDate" placeholder="Select date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>

    <app-searchable-select class="col-md-4"
                           [required]="true"
                           [options]="observerName"
                           [placeholder]="'Select Observer Name'"
                           [label]="'Select Observer Name'"
                           [selectedValue]="{ name: observerForm.get('observerName')?.value }"
                           (selectionChange)="onObserverSelected($event)"
    ></app-searchable-select>
    <!-- Both type fields are derived from the person selected beside them, so they
         are read-only inputs rather than disabled dropdowns: Material greys a
         disabled control out and the value becomes hard to read. -->
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Observer Type</mat-label>
      <input matInput formControlName="observerType" readonly
             placeholder="Set from the selected observer">
      <mat-hint>Set automatically from the observer's role</mat-hint>
    </mat-form-field>

    <app-searchable-select class="col-md-4"
                           [required]="true"
                           [options]="allTeachers"
                           [placeholder]="'Select Teacher Name'"
                           [label]="'Select Teacher Name'"
                           [selectedValue]="{ name: observerForm.get('teacherName')?.value }"
                           (selectionChange)="onTeacherSelected($event)"
    ></app-searchable-select>

    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Teacher Type</mat-label>
      <input matInput formControlName="teacherType" readonly
             placeholder="Set from the selected teacher">
      <mat-hint>Set automatically from the teacher's role</mat-hint>
    </mat-form-field>

    <app-searchable-select class="col-md-4"
                           [required]="true"
                           [options]="allCenters$ | async"
                           [selectedValue]="selectedCentre"
                           [displayWithFn]="displayCentre"
                           [placeholder]="'Select Centre'"
                           [label]="'Select Centre'"
                           (selectionChange)="onCentreSelect($event)"
    ></app-searchable-select>
    <app-searchable-select class="col-md-4"
                           [multiple]="true"
                           [options]="children"
                           [selectedValue]="selectedChild"
                           [valueKey]="'childCode'"
                           [displayWithFn]="displayChild"
                           [placeholder]="'Select Child'"
                           [label]="'Select Child'"
                           (selectionChange)="onChildSelect($event)"
    ></app-searchable-select>

    <app-searchable-select class="col-md-4"
                           [required]="true"
                           [options]="sessionType"
                           [displayWithFn]="sessionDisplay"
                           [selectedValue]="observerForm.get('sessionType')?.value"
                           [label]="'Select Session Type'"
                           (selectionChange)="onSessionSelect($event)"
    ></app-searchable-select>
    <app-searchable-select class="col-md-4"
                           [required]="true"
                           [options]="subjects"
                           [displayWithFn]="subjectsDisplay"
                           [selectedValue]="observerForm.get('subject')?.value"
                           [label]="'Select Subjects Type'"
                           (selectionChange)="onSubjectsSelect($event)"
    ></app-searchable-select>

<!--    <mat-form-field appearance="outline" class="w-100">-->
<!--      <mat-label>Topic</mat-label>-->
<!--      <input matInput maxlength="500" formControlName="topic">-->
<!--      <mat-hint align="end">-->
<!--        {{ topicLength }} / 500-->
<!--      </mat-hint>-->
<!--    </mat-form-field>-->

    <app-searchable-select class="col-12 mt-2"
                           [multiple]="true"
                           [options]="educationObservationTopics$ | async"
                           [displayWithFn]="displayType"
                           [placeholder]="'Select Education Observation topics'"
                           [label]="'Select Topic'"
                           [selectedValue]="selectedEducationObservationTopic"
                           [isShowPlusIcon]="true"
                           [addTooltipPlusIcon]="'Add Education Observation Topic'"
                           (addButtonClicked)="handleAdd($event)"
                           (selectionChange)="onSelectEducationObservationtopics($event)"
    ></app-searchable-select>

    <app-searchable-select class="col-12 mt-2"
                           [multiple]="true"
                           [options]="teachingAids$ | async"
                           [displayWithFn]="displayType"
                           [placeholder]="'Select Teaching Aid'"
                           [label]="'Select Teaching Aid'"
                           [selectedValue]="selectedTeachingAid"
                           [isShowPlusIcon]="true"
                           [addTooltipPlusIcon]="'Add Teaching Aid'"
                           (addButtonClicked)="handleAddTeachingAid($event)"
                           (selectionChange)="onSelectTeachingAids($event)"
    ></app-searchable-select>



<!--    <mat-form-field appearance="outline" class="w-100">-->
<!--      <mat-label>Teaching Aid</mat-label>-->
<!--      <input matInput maxlength="500" formControlName="teachingAid">-->
<!--      <mat-hint align="end">-->
<!--        {{ teachingAidLength }} / 500-->
<!--      </mat-hint>-->
<!--    </mat-form-field>-->

    <div class="col-md-12 mb-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Observation Comment</mat-label>
        <textarea matInput rows="3" formControlName="observationComment" placeholder="Enter Observation Comment"></textarea>
      </mat-form-field>
    </div>

    <!-- Suggestions & Remarks -->
    <div class="col-md-12 mb-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Suggestions & Remarks</mat-label>
        <textarea matInput rows="3" formControlName="suggestions" placeholder="Enter suggestions"></textarea>
      </mat-form-field>
    </div>



    <!-- Submit Button -->
    <div class="col-12 justify-content-center d-flex gap-2">
      <button mat-raised-button color="warn" (click)="onCancel()" >Cancel</button>
      <button mat-raised-button color="primary" [disabled]="observerForm.invalid || isLoading" (click)="submitForm()">{{ currentEditId ? 'Update ':'Submit' }}</button>
    </div>

  </form>
</div>

<!-- Loader Spinner (only visible while loading) -->
<div class="spinner-container" *ngIf="isLoading">
  <mat-spinner diameter="60"></mat-spinner>
</div>
